<template>
    <div class="max-w-7xl mx-auto pr-4 md:px-4">
        <slot />
    </div>
</template>

<script setup>

</script>